import { Locale } from '@/providers/Locale/types'

type TextFields = 'moreStories' | 'userHasNoPosts'

export const i18n: Record<Locale, Record<TextFields, string>> = {
    en: {
        moreStories: 'More stories',
        userHasNoPosts: 'This user has no posts.',
    },
    es: {
        moreStories: 'Más historias',
        userHasNoPosts: 'Este usuario no ha publicado ningún artículo.',
    },
    fr: {
        moreStories: "Plus d'histoires",
        userHasNoPosts: "Cet utilisateur n'a publié aucun article.",
    },
    de: {
        moreStories: 'Mehr Geschichten',
        userHasNoPosts: 'Dieser Benutzer hat keine Artikel veröffentlicht.',
    },
}
